export default __webpack_public_path__ + "static/media/logo.957c8b71.png";